module.exports = __webpack_public_path__ + "static/media/favicon.38128835.ico";